var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CheckIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 16.2322L3.88388 11.6161C3.39573 11.128 2.60427 11.128 2.11612 11.6161C1.62796 12.1043 1.62796 12.8957 2.11612 13.3839L7.61612 18.8839C8.10427 19.372 8.89573 19.372 9.38388 18.8839L21.8839 6.38388C22.372 5.89573 22.372 5.10427 21.8839 4.61612C21.3957 4.12796 20.6043 4.12796 20.1161 4.61612L8.5 16.2322Z",
    fill: ""
  }));
}
export var CheckIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: CheckIconInner
  }, props));
};